__turbopack_context__.v({
  "body_rich_text": "StandardCTA-module-scss-module__ZBo_JW__body_rich_text",
  "direction__column": "StandardCTA-module-scss-module__ZBo_JW__direction__column",
  "direction__row": "StandardCTA-module-scss-module__ZBo_JW__direction__row",
  "gradient-glow-blue": "StandardCTA-module-scss-module__ZBo_JW__gradient-glow-blue",
  "gradient-glow-neon": "StandardCTA-module-scss-module__ZBo_JW__gradient-glow-neon",
  "gradient-glow-orange": "StandardCTA-module-scss-module__ZBo_JW__gradient-glow-orange",
  "gradient-glow-pink": "StandardCTA-module-scss-module__ZBo_JW__gradient-glow-pink",
  "gradient-glow-snap-pea": "StandardCTA-module-scss-module__ZBo_JW__gradient-glow-snap-pea",
  "gradient-neon-pink": "StandardCTA-module-scss-module__ZBo_JW__gradient-neon-pink",
  "gradient-pink-blue": "StandardCTA-module-scss-module__ZBo_JW__gradient-pink-blue",
  "gradient-pink-orange": "StandardCTA-module-scss-module__ZBo_JW__gradient-pink-orange",
  "layout__content-leading": "StandardCTA-module-scss-module__ZBo_JW__layout__content-leading",
  "layout__content-trailing": "StandardCTA-module-scss-module__ZBo_JW__layout__content-trailing",
  "module-base": "StandardCTA-module-scss-module__ZBo_JW__module-base",
  "module-content-swap": "StandardCTA-module-scss-module__ZBo_JW__module-content-swap",
  "module-image": "StandardCTA-module-scss-module__ZBo_JW__module-image",
  "module_block__contained": "StandardCTA-module-scss-module__ZBo_JW__module_block__contained",
  "module_block__uncontained": "StandardCTA-module-scss-module__ZBo_JW__module_block__uncontained",
  "module_breadcrumbs": "StandardCTA-module-scss-module__ZBo_JW__module_breadcrumbs",
  "section_bg_fill__base": "StandardCTA-module-scss-module__ZBo_JW__section_bg_fill__base",
  "section_bg_fill__gradient": "StandardCTA-module-scss-module__ZBo_JW__section_bg_fill__gradient",
  "section_bg_fill__image": "StandardCTA-module-scss-module__ZBo_JW__section_bg_fill__image",
  "section_bg_fill__no-fill": "StandardCTA-module-scss-module__ZBo_JW__section_bg_fill__no-fill",
  "section_bg_fill__raised": "StandardCTA-module-scss-module__ZBo_JW__section_bg_fill__raised",
  "section_container": "StandardCTA-module-scss-module__ZBo_JW__section_container",
  "with_breadcrumb": "StandardCTA-module-scss-module__ZBo_JW__with_breadcrumb",
  "with_navbar": "StandardCTA-module-scss-module__ZBo_JW__with_navbar",
});
